import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import CurrentUser from 'donor-elf-web/services/current-user';
import NavbarSettingsService from 'donor-elf-web/services/navbar-settings';
import {
  type DashboardRouteModel,
  RedirectToNamedDashboardRoute,
} from '../dashboard';

export default class DashboardRoute extends Route {
  @service declare currentUser: CurrentUser;
  @service declare navbarSettings: NavbarSettingsService;
  @service declare router: RouterService;

  model(): DashboardRouteModel {
    return this.modelFor('funds.fund.dashboard') as DashboardRouteModel;
  }

  redirect(model: DashboardRouteModel) {
    RedirectToNamedDashboardRoute({
      model,
      currentUser: this.currentUser,
      transitionTo: this.router.transitionTo.bind(this),
    });
  }
}
